import { useQuery } from "@tanstack/react-query";
import Axios from "../../../Axios/Axios";
import { Urls } from "../../../Urls";

/*
  There is no dedicated spot filters route — confirmed from
  routes/filters.py: every screen (indent_summary, vehicle_allocation,
  vehicle_status, spot) shares GET /tms-dashboard/filters, keyed by the
  `screen` query param. screen="spot" runs a different aggregation branch
  than the indent screens and returns a DIFFERENT shape:

    { plant: [...], destination: [...], transporters: [...], roles: [...] }

  (singular "plant"/"destination", not "plants"/"destinations" like
  indent_summary/vehicle_allocation). Each entry is { location_name }
  only — no location_code for the spot branch.

  plant/destination values returned here are safe to send straight back
  as the `plant`/`destination` params on spot_metrics/spot_funnel/
  top_transporters — same location_name matching on both sides.
*/

export const useSpotDashboardFilters = (
  { startDate, endDate, role, plant, destination, transporterId },
  enabled = true
) => {
  return useQuery({
    queryKey: ["spotDashboardFilters", startDate, endDate, role, plant, destination, transporterId],
    queryFn: async () => {
      const params = new URLSearchParams({ screen: "spot", start_date: startDate, end_date: endDate });
      if (role) params.append("role", role);
      if (plant && plant !== "All") params.append("plant", plant);
      if (destination && destination !== "All") params.append("destination", destination);
      if (transporterId && transporterId !== "All") params.append("transporter_id", transporterId);
      const { data } = await Axios.get(`${Urls.tmsDashboardFilters}?${params.toString()}`);
      return data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};